import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { z } from "zod";

export const memos = [
    "화장실 출입문이 조수석 적재함쪽을 향하도록 상차",
    "오수배출구가(소변기칸에 위치) 잘 잠겨있는지",
    "창문 및 출입문이 닫혀 있는지 점검하여 출발바람(안전사고 예방)",
    "내부에  휴지통이 들어 있는지 체크"
]

// export interface ReturnRequest {
//     id: string;
//     companyName: string;
//     companyAddress: string;
// 	productName: string;
// 	size: string;
// 	vehicleWeight: string;
// 	vehicleNumber: number;
// 	memo: string[];
// 	returnTime: string;
// 	personInCharge: string;
// 	mobileInCharge: string;
//     createTime: string;
// 	modifiedTime?: string;
// }


export const returnRequestSchema = z.object({
  id: z.string().uuid("올바른 UUID 형식이 아닙니다."),
  companyName: z.string().min(1, "회사명을 입력해 주세요."),
  companyAddress: z.string().min(1, "회사 주소를 입력해 주세요."),
  productName: z.string().min(1, "제품명을 입력해 주세요."),
  size: z.string().min(1, "규격을 입력해 주세요."),
  vehicleWeight: z.string().min(1, "총중량을 입력해 주세요."),
  vehicleNumber: z
    .number()
    .int()
    .nonnegative(),
  memo: z.array(z.string().max(500, "메모는 500자를 넘을 수 없습니다.")).optional(),
  returnTime: z
    .string()
    .nonempty("회수일시를 입력해 주세요.")
    .regex(
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/,
      "회수일시는 yyyy-MM-ddTHH:mm 형식이어야 합니다.",
    ), // 예: 2025-11-29T15:30
  personInCharge: z.string().min(1, "담당자명을 입력해 주세요."),
  mobileInCharge: z
    .string()
    .min(1, "담당자 연락처를 입력해 주세요.")
    .regex(/^[0-9\-+ ]+$/, "연락처 형식이 올바르지 않습니다."),
  createTime: z.string(),          // 서버에서 세팅하면 여기선 그냥 string
  modifiedTime: z.string().optional(),
});

export type ReturnRequest = z.infer<typeof returnRequestSchema>;

export const defaultReturnRequest: ReturnRequest = {
    id: "",
    companyName: "",
    companyAddress: "",
	productName: "",
	size: "",
	vehicleWeight: "",
	vehicleNumber: 1,
	memo: memos,
	returnTime: "",
	personInCharge: "",
	mobileInCharge: "",
    createTime: dayjs().tz('Asia/Seoul')
                      .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
	modifiedTime: "",
}

export const returnRequestFields = [
  { label: "제품명", name: "productName", type: "string", required: true, multiline: false },
  { label: "규격", name: "size", type: "string", required: true, multiline: false },
  { label: "배차차량 톤수", name: "vehicleWeight", type: "string", required: true, multiline: false },
  { label: "차량대수", name: "vehicleNumber", type: "number", required: true, multiline: false },
  { label: "상차지 회사명", name: "companyName", type: "string", required: true, multiline: false },
  { label: "상차지 주소", name: "companyAddress", type: "string", required: true, multiline: false },
  { label: "담당자 명", name: "personInCharge", type: "string", required: true, multiline: false },
  { label: "담당자 연락처", name: "mobileInCharge", type: "string", required: true, multiline: false },
]

